import type { ComponentType } from 'react';
import { ROUTES } from '../../constants/constants';
import { FeatureSelectionTab } from '../../interface/featureSelection';
import { DocumentTextOutline, LinearDanger, LinearNoteAdd, Notes, ReceiveOutline } from '../icons';

export interface QuickActionItem {
  key: string;
  route: string;
  translationKey: string;
  icon: ComponentType<Readonly<{ className?: string }>>;
  featureKey: FeatureSelectionTab;
  requiresMatterRequests?: boolean;
}

export interface QuickActionGroup {
  key: string;
  headingKey: string;
  actions: QuickActionItem[];
}

export const QUICK_ACTION_GROUPS: QuickActionGroup[] = [
  {
    key: 'tasks',
    headingKey: 'common:quickActionItems.groups.tasks',
    actions: [
      {
        key: 'task',
        route: ROUTES.ADD_EDIT_TASK,
        translationKey: 'common:quickActionItems.newTask',
        icon: Notes,
        featureKey: FeatureSelectionTab.tasks,
      },
      {
        key: 'criticalTask',
        route: ROUTES.ADD_EDIT_CRITICAL_TASK,
        translationKey: 'common:quickActionItems.newCriticalTask',
        icon: LinearDanger,
        featureKey: FeatureSelectionTab.tasks,
      },
    ],
  },
  {
    key: 'timeAndBilling',
    headingKey: 'common:quickActionItems.groups.timeAndBilling',
    actions: [
      {
        key: 'workTime',
        route: ROUTES.ADD_EDIT_WORK_TIME,
        translationKey: 'common:quickActionItems.newWorkTime',
        icon: LinearNoteAdd,
        featureKey: FeatureSelectionTab.workTimes,
      },
      {
        key: 'transaction',
        route: ROUTES.ADD_EDIT_TRANSACTION,
        translationKey: 'common:quickActionItems.newTransaction',
        icon: DocumentTextOutline,
        featureKey: FeatureSelectionTab.dashboard,
      },
    ],
  },
  {
    key: 'matters',
    headingKey: 'common:quickActionItems.groups.matters',
    actions: [
      {
        key: 'matterRequest',
        route: ROUTES.MANAGE_MATTER_REQUEST,
        translationKey: 'common:quickActionItems.newMatterRequest',
        icon: ReceiveOutline,
        featureKey: FeatureSelectionTab.matters,
        requiresMatterRequests: true,
      },
    ],
  },
];

export const resolveVisibleQuickActionGroups = (
  groups: QuickActionGroup[],
  isActionVisible: (action: QuickActionItem) => boolean,
) =>
  groups
    .map((group) => ({ ...group, actions: group.actions.filter(isActionVisible) }))
    .filter((group) => group.actions.length > 0);
